export default __webpack_public_path__ + "static/media/011-shield.b3c86e23.png";